import React, { useEffect } from "react";
import { CallAPI } from "services/API";
import TableWithContainer from "utils/Table/TableWithContainer";

export default function CreditScore(props) {
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const headers = [[
        props.type == "Quotes" ? "Quote Type" : "Policy Type",
        props.type,
        "599 And Under",
        "600-699",
        "700 And Over"
    ]];

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
        
    const GetData = async () => {
        const response = await CallAPI("POST", `/Home/Get${props.type}CreditScore`, {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            getQuoteType: props.getQuoteType
        });
            
        if (response) {
            const formattedResponse = response.map((row) => [
                row.policyType || row.quoteType,
                integer.format(row.policies || row.quotes),
                integer.format(row.score599AndUnder),
                integer.format(row.score600To699),
                integer.format(row.score700AndOver),
            ]);

            if (props.comments?.length > 0) {
                headers[0].push('');
                formattedResponse.map(x => {
                    let comment = props.comments.find(y => y.row.toLowerCase() == x[0].toLowerCase());
                    x.push(comment ? comment.message : '');
                });
            }
                
            setData(formattedResponse);
        }
            
        setLoading(false);
    };
        
    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetData();
            setLoading(true);
        }
    }, [props.call]);

    return (
        <div>
            <TableWithContainer
                title={`${props.type.toUpperCase()} - CREDIT SCORE SURVEY SELECTION`}
                loading={loading}
                fixedColumns={1}
                style={{
                    Table: {
                        TableSX: { tableLayout: 'fixed' }, // all columns same width
                    }
                }}
                headers={headers}
                rows={data.filter(x => x[0] !== 'TOTAL')}
                footers={data.filter(x => x[0] === 'TOTAL')}
                exportName={`${props.type}CreditScore`}
            />
        </div>
    );
};
